import React from 'react'
import { withRouteData, Link } from 'react-static'

import Title from '../components/Title'
import Transitionable from './Transitionable'
import Sidebar from '../components/Sidebar'

import styles from './Blog/styles.module.css'
import postStyles from '../components/BlogPost/styles.module.css'

class About extends Transitionable {

  robotState = 'blog'

  renderTransitioned() {
    return withRouteData(({ page }) => ( 
      <section className={styles.blog}>
          <Title page={page.title} />
          <Sidebar />
          <article className={postStyles.blogPost}>
            <div className={postStyles.body} dangerouslySetInnerHTML={{ __html: page.contents }} />
          </article>
      </section>
    ))()
  }

}

export default About



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/About.js